module.exports = __webpack_public_path__ + "static/media/kids.0f03c1e3.png";